module.exports = __webpack_public_path__ + "static/media/sleep-well.cd0c0a4c.jpg";